import React, { SFC, MouseEventHandler } from 'react';
import classNames from 'classnames';

interface Button {
  type: 'primary' | 'secondary' | 'cta-primary' | 'cta-secondary' | 'cta-alt';
  disabled?: boolean;
  onClick?: MouseEventHandler;
}

export const Button: SFC<Button> = ({ type, disabled, onClick, children }) => {
  const isPrimary = type.endsWith('primary');
  const isSecondary = type.endsWith('secondary');
  const isCallToAction = type.startsWith('cta');

  return (
    <button
      className={classNames({
        button: !isCallToAction,
        'button-cta': isCallToAction,
        'button-primary': isPrimary,
        'button-secondary': isSecondary,
        'button-rounded': !isCallToAction,
        'button-primary-alt': type === 'cta-alt',
        'is-disabled': disabled,
      })}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
